import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=46855f17&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46855f17')) {
      api.createRecord('46855f17', component.options)
    } else {
      api.reload('46855f17', component.options)
    }
    module.hot.accept("./BasePage.vue?vue&type=template&id=46855f17&", function () {
      api.rerender('46855f17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/BasePage.vue"
export default component.exports